// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    line-height: 1.5;
    color: #1a1a1a;
}

* {
    box-sizing: border-box;
}

h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.3;
    margin: 0;
}

code {
    font-family: 'Roboto Mono', 'Fira Code', 'Consolas', 'Monaco', monospace;
    font-size: 0.9em;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,kHAAkH;IAClH,mCAAmC;IACnC,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,wEAAwE;IACxE,gBAAgB;AACpB","sourcesContent":["body {\n    margin: 0;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #1a1a1a;\n}\n\n* {\n    box-sizing: border-box;\n}\n\nh1, h2, h3, h4, h5, h6 {\n    font-weight: 600;\n    line-height: 1.3;\n    margin: 0;\n}\n\ncode {\n    font-family: 'Roboto Mono', 'Fira Code', 'Consolas', 'Monaco', monospace;\n    font-size: 0.9em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
